module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 5K Monitor 27\".8b887d5f.png";